const BILLING_CHANGED_EVENT = 'ee:billing-changed';

/**
 * Announces that the workspace's billing state changed: its subscription (a completed checkout, a
 * plan change, a seat change, a cancel) or the seats it uses (a member invited or removed).
 * Anything else on screen that holds its own copy of billing state -- the seats banner and the plan
 * gate's seat allocation, which otherwise only fetch when the workspace changes -- refetches on
 * this instead of going stale until a full page reload.
 */
export function notifyBillingChanged(): void {
  window.dispatchEvent(new Event(BILLING_CHANGED_EVENT));
}

/**
 * Subscribes to notifyBillingChanged. Returns the unsubscribe, so it can be returned straight
 * from an effect.
 */
export function onBillingChanged(listener: () => void): () => void {
  window.addEventListener(BILLING_CHANGED_EVENT, listener);
  return () => window.removeEventListener(BILLING_CHANGED_EVENT, listener);
}
